import axios from "axios";
import { eTripB2bApi } from "b2b-common";
export const transport = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || "/server/",
  withCredentials: true,
  timeout: 120000,
});
export const api = new eTripB2bApi(transport);
// Never replay mutations: a timed-out booking may already exist on the server.
transport.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401)
      window.dispatchEvent(new Event("hello:session-expired"));
    return Promise.reject(error);
  },
);

// Local extensions share authentication, timeouts and error handling with b2b-common.
import { BusClient, OfferDocumentsClient } from "./extended-client";
export const busApi = new BusClient(transport);
export const offerDocuments = new OfferDocumentsClient(transport);
